import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/**
 * Kime-no-Kata — Idori / Tachiai.
 * Repeated English names remain separate scoped IDs.
 */
export const kimeNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'kime-no-kata',
  name: 'Kime-no-Kata',
  nameJa: '極の形',
  theme: {
    from: '#5b21b6',
    to: '#f472b6',
    text: '#ffffff',
  },
  groups: [
    {
      id: 'idori',
      name: 'Idori',
      nameJa: '居取',
      techniques: [
        { id: 'kime-idori-ryote-dori', name: 'Ryote-dori', nameJa: '両手取' },
        { id: 'kime-idori-tsukkake', name: 'Tsukkake', nameJa: '突掛' },
        { id: 'kime-idori-suri-age', name: 'Suri-age', nameJa: '摺上' },
        { id: 'kime-idori-yoko-uchi', name: 'Yoko-uchi', nameJa: '横打' },
        { id: 'kime-idori-ushiro-dori', name: 'Ushiro-dori', nameJa: '後取' },
        { id: 'kime-idori-tsukkomi', name: 'Tsukkomi', nameJa: '突込' },
        { id: 'kime-idori-kirikomi', name: 'Kiri-komi', nameJa: '切込' },
        { id: 'kime-idori-yoko-tsuki', name: 'Yoko-tsuki', nameJa: '横突' },
      ],
    },
    {
      id: 'tachiai',
      name: 'Tachiai',
      nameJa: '立合',
      techniques: [
        { id: 'kime-tachiai-ryote-dori', name: 'Ryote-dori', nameJa: '両手取' },
        { id: 'kime-tachiai-sode-tori', name: 'Sode-tori', nameJa: '袖取' },
        { id: 'kime-tachiai-tsukkake', name: 'Tsukkake', nameJa: '突掛' },
        { id: 'kime-tachiai-tsuki-age', name: 'Tsuki-age', nameJa: '突上' },
        { id: 'kime-tachiai-suri-age', name: 'Suri-age', nameJa: '摺上' },
        { id: 'kime-tachiai-yoko-uchi', name: 'Yoko-uchi', nameJa: '横打' },
        { id: 'kime-tachiai-ke-age', name: 'Ke-age', nameJa: '蹴上' },
        { id: 'kime-tachiai-ushiro-dori', name: 'Ushiro-dori', nameJa: '後取' },
        { id: 'kime-tachiai-tsukkomi', name: 'Tsukkomi', nameJa: '突込' },
        { id: 'kime-tachiai-kirikomi', name: 'Kiri-komi', nameJa: '切込' },
        { id: 'kime-tachiai-nuki-kake', name: 'Nuki-kake', nameJa: '抜掛' },
        { id: 'kime-tachiai-kiri-oroshi', name: 'Kiri-oroshi', nameJa: '切下' },
      ],
    },
  ],
})
